import axios from 'axios';

export default async function Axios (url, method, params, config) {
  const {data} = await axios[method](url, params, Object.assign({}, config));
  return data;
}